import { getLuminance } from 'polished';

export default function checkDarKMode(background) {
  return getLuminance(background) < 0.5;
}
